import React, { useContext } from "react";
import useTranslation from "../../../hooks/useTranslation";
import { useBaseManagement } from "../../../hooks/productManagement";
import FeaturePageLayout from "../../Shared/FeaturePageLayout/FeaturePageLayout";
import FeatureHeader from "../../Shared/FeaturePageLayout/FeatureHeader/FeatureHeader";
import FeatureTable from "../../Shared/FeaturePageLayout/FeatureTable/FeatureTable";
import FeaturePagination from "../../Shared/FeaturePageLayout/FeaturePagination/FeaturePagination";
import EditBaseModal from "./EditBaseModal/EditBaseModal";
import ConfirmationModal from "../../Shared/ConfirmationModal/ConfirmationModal";
import { faCaretDown } from "../../../helpers/icons/fontAwesomeIcons";
import UserContext from "../../../context/UserContext";
import USER_ROLES from "../../../constants/userRoles";

const BasesSection = () => {
  const { t } = useTranslation("productManagerPage");
  const { user } = useContext(UserContext);
  const isSuperAdmin = user && user.roles === USER_ROLES.SUPER_ADMIN;

  const {
    // State
    setSearchTerm,
    /*         showAddModal,
        setShowAddModal, */
    showEditModal,
    setShowEditModal,
    selectedBase,
    showDeleteConfirmation,
    baseToDelete,
    filteredBases,
    recordsPerPage,
    setRecordsPerPage,
    currentPage,
    setCurrentPage,
    loadingBases,
    paginatedBases,
    companies,
    selectedCompany,
    setSelectedCompany,

    // Functions
    /*         handleAddBase, 
        handleSaveBase,*/
    handleUpdateBase,
    handleConfirmDelete,
    handleCancelDelete,
    handleActionClick,
  } = useBaseManagement();

  const baseColumns = [
    {
      key: "baseid",
      label: t("baseid"),
      render: (row) => row?.baseid || "-",
    },
    {
      key: "hw",
      label: t("hardware"),
      render: (row) => row?.hw || "-",
    },
    {
      key: "sw",
      label: t("software"),
      render: (row) => row?.sw || "-",
    },
    {
      key: "pin",
      label: t("pin"),
      render: (row) => row?.pin || "-",
    },
    {
      key: "apn1",
      label: t("apn1"),
      render: (row) => row?.apn1 || "-",
    },
    {
      key: "apn2",
      label: t("apn2"),
      render: (row) => row?.apn2 || "-",
    },
    {
      key: "gprsusername1",
      label: t("gprsusername1"),
      render: (row) => row?.gprsusername1 || "-",
    },
    {
      key: "gprsusername2",
      label: t("gprsusername2"),
      render: (row) => row?.gprsusername2 || "-",
    },
    {
      key: "gprspassword1",
      label: t("gprspassword1"),
      render: (row) => row?.gprspassword1 || "-",
    },
    {
      key: "gprspassword2",
      label: t("gprspassword2"),
      render: (row) => row?.gprspassword2 || "-",
    },
    {
      key: "gprsuserparam11",
      label: t("gprsuserparam11"),
      render: (row) => row?.gprsuserparam11 || "-",
    },
    {
      key: "gprsuserparam21",
      label: t("gprsuserparam21"),
      render: (row) => row?.gprsuserparam21 || "-",
    },
    {
      key: "gprsuserparam12",
      label: t("gprsuserparam12"),
      render: (row) => row?.gprsuserparam12 || "-",
    },
    {
      key: "gprsuserparam22",
      label: t("gprsuserparam22"),
      render: (row) => row?.gprsuserparam22 || "-",
    },
    {
      key: "serveraddress1",
      label: t("serveraddress1"),
      render: (row) => row?.serveraddress1 || "-",
    },
    {
      key: "serveraddress2",
      label: t("serveraddress2"),
      render: (row) => row?.serveraddress2 || "-",
    },
    {
      key: "serverport1",
      label: t("serverport1"),
      render: (row) => row?.serverport1 || "-",
    },
    {
      key: "serverport2",
      label: t("serverport2"),
      render: (row) => row?.serverport2 || "-",
    },
    {
      key: "gprscycletime",
      label: t("gprscycletime"),
      render: (row) => row?.gprscycletime || "-",
    },
    {
      key: "gprserrordelay",
      label: t("gprserrordelay"),
      render: (row) => row?.gprserrordelay || "-",
    },
    {
      key: "gprsretrycount",
      label: t("gprsretrycount"),
      render: (row) => row?.gprsretrycount || "-",
    },
    {
      key: "basefiltering",
      label: t("basefiltering"),
      render: (row) => row?.basefiltering || "-",
    },
    {
      key: "modbusenabled",
      label: t("modbusenabled"),
      render: (row) => (row?.modbusenabled ? t("yes") : t("no")),
    },
    {
      key: "modbusaddress",
      label: t("modbusaddress"),
      render: (row) => row?.modbusaddress || "-",
    },
    {
      key: "modbusbaudrate",
      label: t("modbusbaudrate"),
      render: (row) => row?.modbusbaudrate || "-",
    },
    {
      key: "modbusconfig",
      label: t("modbusconfig"),
      render: (row) => row?.modbusconfig || "-",
    },
    {
      key: "probesamplecount",
      label: t("probesamplecount"),
      render: (row) => row?.probesamplecount || "-",
    },
    {
      key: "probesampletime",
      label: t("probesampletime"),
      render: (row) => row?.probesampletime || "-",
    },
    {
      key: "gprscontcomm",
      label: t("gprscontcomm"),
      render: (row) => row?.gprscontcomm || "-",
    },
    {
      key: "loggedin",
      label: t("loggedin"),
      render: (row) => (row?.loggedin ? t("yes") : t("no")),
    },
    {
      key: "modifyconfig",
      label: t("modifyconfig"),
      render: (row) => (row?.modifyconfig ? t("yes") : t("no")),
    },
    {
      key: "logoutdate",
      label: t("logoutdate"),
      render: (row) => row?.logoutdate || "-",
    },
    {
      key: "logindate",
      label: t("logindate"),
      render: (row) => row?.logindate || "-",
    },
    {
      key: "products_id",
      label: t("productsId"),
      render: (row) => row?.products_id || "-",
    },
    {
      key: "active",
      label: t("active"),
      render: (row) => (row?.active ? t("yes") : t("no")),
    },
    {
      key: "archivedatacount",
      label: t("archivedDataCount"),
      render: (row) => row?.archivedatacount || "-",
    },
    {
      key: "measvalidtime",
      label: t("measvalidtime"),
      render: (row) => row?.measvalidtime || "-",
    },
    {
      key: "validconfig",
      label: t("validConfig"),
      render: (row) => (row?.validconfig ? t("yes") : t("no")),
    },
    {
      key: "sim_id",
      label: t("sim"),
      render: (row) => row?.sim_id || "-",
    },
    {
      key: "companies_id",
      label: t("company"),
      render: (row) => {
        const company = companies?.find(
          (c) => c.companyid === row?.companies_id
        );
        return company ? company.companyname : row?.companies_id || "-";
      },
    },
    {
      key: "simcard",
      label: t("sim"),
      render: (row) => row?.simcard || "-",
    },
  ];

  const selectors = isSuperAdmin
    ? [
        {
          items: companies,
          loading: false,
          selectedValue: selectedCompany,
          onChange: setSelectedCompany,
          valueField: "companyid",
          labelField: "companyname",
          placeholderKey: "company",
          icon: faCaretDown,
        },
      ]
    : [];

  return (
    <>
      <FeaturePageLayout>
        <FeatureHeader
          t={t}
          title={t("bases")}
          search={setSearchTerm}
          selectors={selectors}
          showCompanySelector={true}
          selectedCompany={selectedCompany}
          onCompanyChange={setSelectedCompany}
          selectorUniqeClassname="product-manager-page__base-company-selector"
          display={{
            count: recordsPerPage,
            onChange: setRecordsPerPage,
            options: [5, 10, 20, 50],
          }}
          /* actionButton={
            isSuperAdmin
              ? {
                  onClick: handleAddBase,
                  icon: <FontAwesomeIcon icon={faPlus} />,
                  label: "add_base",
                }
              : null
          } */
        />
        {/* Render base table or list here */}
        <FeatureTable
          t={t}
          data={paginatedBases || []}
          columns={baseColumns}
          tableType="bases"
          pagination={null}
          loading={loadingBases}
          actions={{
            view: true,
            edit: true,
            delete: true,
            custom: [],
          }}
          onActionClick={handleActionClick}
        />
      </FeaturePageLayout>
      {filteredBases && filteredBases.length > 0 && (
        <div className="pagination-container">
          <FeaturePagination
            t={t}
            currentPage={currentPage}
            totalPages={Math.ceil(
              (filteredBases?.length || 0) / recordsPerPage
            )}
            onPageChange={setCurrentPage}
          />
        </div>
      )}
      {/* Modals for adding, editing and deleting products */}
      {/*       <AddSimCardModal
        t={t}
        show={showAddModal}
        onClose={() => setShowAddModal(false)}
        onSave={handleSaveSimCard}
        tableType="bases"
      /> */}

      <EditBaseModal
        t={t}
        show={showEditModal}
        onClose={() => setShowEditModal(false)}
        base={selectedBase}
        onSave={handleUpdateBase}
        tableType="bases"
      />

      <ConfirmationModal
        isVisible={showDeleteConfirmation}
        onConfirm={() => handleConfirmDelete(baseToDelete)}
        onCancel={handleCancelDelete}
        message={
          baseToDelete
            ? t("confirm_delete_base", {
                base: baseToDelete.baseid,
              })
            : ""
        }
      />
    </>
  );
};

export default BasesSection;
